export default __webpack_public_path__ + "static/media/alert.66502aa4.svg";